import React from 'react';

import { Typography } from '@material-ui/core';
import { SelectField, Step } from '../SteppedForm';


const StepPaymentTerm = (props) => {
  return (
    <Step id="paymenttermstep" 
    title="Choose your Payment Terms">
      <Typography style={{ textAlign: 'left'}} class="text">
      <div><h4>Select your Preferred Payment Cycle</h4></div>
      You have the choice of how you would like to pay your licence fees. 
      </Typography>
      <SelectField
        id="paymentcycle"
        label="Please select your preference:"
        values={props.config?.payment_cycles}
        helperText={false}
        required
      />
      <Typography style={{ textAlign: 'left', fontSize: '10px', padding:'0 0 50px 0' }} class="text">
      Note: Weekly payments will be charged every Monday. Choosing this billing cycle, you ensure that you will clear this payment by the Sunday of that week. Monthly payments will be charged on the first business day of the month. Choosing this billing cycle, you ensure that you will clear your payment by the 15th of the month. You can switch between monthly and weekly billing cycles once per month by completing a form. You must complete your request by the 23rd of the month. All requests must be completed by the cutoff date and the new billing cycle will take effect the next calendar month. When you change cycles, a changeover fee of $4.90 and any pro-rata days between cycles (if applicable) will be applied to your account. The weekly network fee rate is calculated as the weekly rate of the monthly network fee amount plus an administration fee of $1.90 per week.
      </Typography>

      {props.stateconfig().securitydeposit ? (<>
      <Typography style={{ textAlign: 'left' }} class="text">            
      <div><h4>Security Deposit</h4></div>
      Before you commence operating with us, we require a security deposit equivalent to one month’s network fees.
      </Typography>
     
      <SelectField
        id="securitydeposit"
        label="Please select your preference:"
        values={props.config?.security_deposit_options}
        helperText={false}
        required
      />
      <div style={{ textAlign: 'left', fontSize:'10px',padding:'0 0 50px 0' }} class="text">
      Note: should you terminate your contract with us, you will receive the security deposit amount, minus any outstanding debts within 90 days of your vehicle being deinstalled.  
      </div></>) : ('')}
    </Step>
  );
};

export default StepPaymentTerm;
